import { z } from 'zod';

export const PayCorrectionDisplayType = z.enum([
  'acceptable',
  'needs-attention',
  'all-employees',
  'pay-grade',
  'chart',
]);

export type PayCorrectionDisplayType = z.infer<typeof PayCorrectionDisplayType>;

export const PayCorrectionDisplayTypes = Object.values(
  PayCorrectionDisplayType.Values,
);
